import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Filter from "./non_confirming_repo_filter/Filter";
import Table from "./non_confirming_repo_table/Table";
import {
  GetCustomerReport,
  GetNonConformingReport,
} from "../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../features/admin/quality_management/process_requirement/non_confirming_work/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";

const Non_Confirming_Repo = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const non_confirming_workdetails = useSelector(
    (state) => state.non_confirming_work,
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState(null);

  const handleEdit = (id) => {
    setEditData(id);
    setIsEdit(true);
  };
  const [searchParams, setSearchParams] = useState({
    status_id: "",
    department_id: "",
    end_date: "",
    start_date: "",
  });
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: non_confirming_workdetails.per_page,
        status_id: searchParams?.status_id?.value,
        department_id: searchParams?.department_id?.value,
        end_date: searchParams.end_date,
        start_date: searchParams.start_date,
      }),
    );
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReportPermission = permissions?.includes(
    FixIDS.non_confirming_work_report.Report,
  );

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetNonConformingReport({
        page: 1,
        per_page: non_confirming_workdetails.per_page,
        status_id: searchParams?.status_id?.value,
        department_id: searchParams?.department_id?.value,
        end_date: searchParams.end_date,
        start_date: searchParams.start_date,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Non Confirming Work Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        {haveReportPermission && (
          <Table non_confirming_workdetails={non_confirming_workdetails} />
        )}
      </div>
      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Non Confirming Work Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Non_Confirming_Repo;
